import { render } from "./EvaluationsList.vue?vue&type=template&id=4ec512a4"
import script from "./EvaluationsList.vue?vue&type=script&lang=js"
export * from "./EvaluationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__